// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pu8u","footer":"styles_footer__2C_ME","passCodeTooltip":"styles_passCodeTooltip__179JU"};